import React, {useContext} from 'react'
import {ShoppingCartContext} from '../../../context/ShoppingCartContext.jsx'
import {
    itemBag as textsItemBag,
    paymentMethods as textsPaymentMethods,
    shoppingCart as textsShoppingCart
} from '../../../translate/Translate.jsx'

import {getSession} from '../../../hooks/useStorage/useStorage.jsx'

import './descriptionValues.scss'

const DescriptionValues = () => {
    const {totalItems, deliveryFee, discount, cashbackBonus} = useContext(ShoppingCartContext)
    const change = getSession('change', 0)
    const rescue = getSession('rescue', 0)
    const changeValue = ((change) - (((totalItems + deliveryFee) - discount) - rescue))
    return <div className={'description-values'}>
        <div className={'div-data-order-summary-values'}>
            <div className={'div-title'}>
                <label className={'title'}>
                    {textsItemBag.summaryValues}
                </label>
            </div>
            <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.subtotal}
                </label>
                <label className={'value'}>
                    {totalItems.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            {(!!deliveryFee) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.deliveryFee}
                </label>
                <label className={'value'}>
                    {deliveryFee.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>}
            {(discount > 0) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.discount}
                </label>
                <label className={'value'}>
                    {`- ${discount.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
            </div>}
            {(rescue > 0) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.cashback}
                </label>
                <label className={'value'}>
                    {`- ${rescue.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
            </div>}
            <div className={'div-values'}>
                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                    {textsShoppingCart.total}
                </label>
                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                    {(((totalItems + deliveryFee) - (discount || 0)) - rescue).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            {(change > 0) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsShoppingCart.totalToPay}
                </label>
                <label className={'value'}>
                    {change.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>}
            {(changeValue > 0) && <div className={'div-values'}>
                <label className={'description'}>
                    {textsPaymentMethods.change}
                </label>
                <label className={'value'}>
                    {changeValue.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>}
        </div>
    </div>
}

export default DescriptionValues
